import React from "react";
import { X, Receipt, User, Calendar } from "lucide-react";

function BillingDetailsModal({ open, onClose, data }) {
  if (!open || !data) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">

      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white w-[500px] rounded-xl shadow-xl border border-slate-200">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <Receipt className="text-blue-600" size={20} />
            <h2 className="text-lg font-semibold text-slate-800">
              Billing Rule Details
            </h2>
          </div>

          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4 text-sm">

          <div className="grid grid-cols-2 gap-4">

            <div>
              <span className="text-slate-500">ID</span>
              <div className="font-medium text-slate-800">
                {data.id}
              </div>
            </div>

            <div>
              <span className="text-slate-500">Master Type</span>
              <div className="font-medium text-slate-800 capitalize">
                {data.master_type.replace("_", " ")}
              </div>
            </div>

            <div>
              <span className="text-slate-500">User ID</span>
              <div className="font-medium text-slate-800">
                {data.user_id ?? "-"}
              </div>
            </div>

            <div>
              <span className="text-slate-500">Min Bill Amount</span>
              <div className="font-medium text-slate-800">
                ₹ {Number(data.min_bill_amount).toLocaleString()}
              </div>
            </div>

            <div>
              <span className="text-slate-500">Status</span>
              <div>
                {data.is_active ? (
                  <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-700 font-medium">
                    Active
                  </span>
                ) : (
                  <span className="px-2 py-1 text-xs rounded-full bg-red-100 text-red-700 font-medium">
                    Inactive
                  </span>
                )}
              </div>
            </div>

            <div>
              <span className="text-slate-500">Created By</span>
              <div className="font-medium text-slate-800">
                {data.created_by}
              </div>
            </div>

            <div>
              <span className="text-slate-500">Updated By</span>
              <div className="font-medium text-slate-800">
                {data.updated_by}
              </div>
            </div>

            <div>
              <span className="text-slate-500 flex items-center gap-1">
                <Calendar size={14} />
                Created At
              </span>
              <div className="font-medium text-slate-800">
                {new Date(data.created_at).toLocaleString()}
              </div>
            </div>

            <div>
              <span className="text-slate-500 flex items-center gap-1">
                <Calendar size={14} />
                Updated At
              </span>
              <div className="font-medium text-slate-800">
                {new Date(data.updated_at).toLocaleString()}
              </div>
            </div>

          </div>

        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-slate-200">

          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg border border-slate-300 text-slate-600 hover:bg-slate-50"
          >
            Close
          </button>

        </div>

      </div>
    </div>
  );
}

export default BillingDetailsModal;